import { IconWrapper } from '../runtime';
export default IconWrapper('filter', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M13.3758 1.74973H2.67364C2.4139 1.74973 2.2769 2.05736 2.45065 2.25042L6.50003 6.74973V12.8019C6.50003 12.9219 6.57155 13.0304 6.68185 13.0777L9.58185 14.3205C9.77981 14.4054 10 14.2602 10 14.0448V6.74973L13.6101 2.23713C13.7672 2.0407 13.6274 1.74973 13.3758 1.74973Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});